import React, { FC } from 'react';
import { Text, View } from 'react-native';
import { scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';
import { WithColor } from '@styles/colors';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import i18n from 'i18n-js';

interface BlockTitleProps extends WithColor {
  title: string;
  scale?: ScaleFunction;
  font?: typeof initialFont;
  testID?: string;
}

export const BlockTitle: FC<BlockTitleProps> = ({ title, C, scale: scaleProp = initialScale, font: fontProp = initialFont, testID }) => {
  return (
    <View testID={testID} style={{ height: scaleProp(31), flexDirection: 'row', alignItems: 'center', paddingLeft: scaleProp(15) }}>
      <Text numberOfLines={1} style={[fontProp.Footnote, { color: C('Label/Light/Tertiary') }]}>
        {i18n.t(title)}
      </Text>
    </View>
  );
};
